import React from "react";
import {
  Drawer,
  Button,
  Input,
  Form,
  Table,
  Row,
  Col,
  Popconfirm,
  notification,
  message,
} from "antd";
import { withRouter } from "react-router-dom";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { axiosInstance } from "../../../commons/commons";
import { buildingAssetSubLocation } from "../../../constants/url";

class AssetSubLocation extends React.Component {
  state = {
    drawerIsVisible: false,
    editFormFields: [],
    tableData: {
      list: [],
      loading: true,
    },
  };

  formRef = null;

  columns = [
    {
      title: "S.N",
      dataIndex: "SN",
      key: "SN",
      align: "center",
      fixed: "left",
      width: 50,
    },
    {
      title: "Sub Location Name",
      dataIndex: "SubLocationName",
      key: "SubLocationName",
      align: "center",
      width: 100,
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      align: "center",
      fixed: "right",
      width: 80,
      render: (_, item) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <EditOutlined
              style={{ color: "#1890ff" }}
              onClick={() => {
                let state = this.state;
                const tempList = [];
                Object.keys(item).map((key) => {
                  tempList.push({ name: key, value: item[key] });
                  return key;
                });
                state.editFormFields = tempList;
                state.drawerIsVisible = true;
                this.setState(state);
              }}
            />
            <Popconfirm
              title="Are you sure to delete ?"
              onConfirm={() => {
                axiosInstance
                  .delete(buildingAssetSubLocation + "/" + item.SubLocationID)
                  .then((res) => {
                    if (res.data.success)
                      notification.success({
                        duration: 3,
                        message: "Success",
                        description: res.data.message || "Done!",
                      });
                    else
                      notification.success({
                        duration: 3,
                        message: "Fail",
                        description:
                          res.data.message || "Something went wrong!",
                      });
                    this.getInitialState().then((st) => {
                      this.resetFields();
                      this.setState(st);
                    });
                  })
                  .catch(() => {});
              }}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <DeleteOutlined style={{ color: "red" }} />
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  getInitialState = async (drawerIsVisible) => {
    let state = {
      drawerIsVisible: drawerIsVisible || false,
      editFormFields: [],
      tableData: {
        list: this.state.tableData.list,
        loading: false,
      },
    };
    await axiosInstance
      .get(buildingAssetSubLocation)
      .then((res) => {
        if (res.data.success) {
          state.tableData.list = res.data.message.map((data, index) => {
            data.SN = index + 1;
            data.key = index;
            return data;
          });
        }
      })
      .catch(() => {});
    return state;
  };

  resetFields = () => {
    if (this.formRef) {
      this.formRef.resetFields();
    }
  };
  onReset = () => {
    this.getInitialState().then((st) => this.setState(st));
  };

  onCreateNew = (drawerIsVisible = false) => {
    return this.formRef
      .validateFields()
      .then((values) => {
        for (let row of this.state.tableData.list)
          if (
            !this.state.editFormFields.length &&
            row.SubLocationName.toLowerCase() ===
              values.SubLocationName.toLowerCase()
          )
            return message.error(
              "Cannot create multiple data for the same location name !"
            );
        this.setState({
          tableData: { list: this.state.tableData.list, loading: true },
        });
        (this.state.editFormFields.length
          ? axiosInstance.put(buildingAssetSubLocation, {
              SubLocationID: values.SubLocationID,
              SubLocationName: values.SubLocationName,
            })
          : axiosInstance.post(buildingAssetSubLocation, {
              SubLocationName: values.SubLocationName,
            })
        )
          .then((res) => {
            if (res && res.data.success) {
              notification.success({
                duration: 3,
                message: "Success",
                description: res.data.message || "Done!",
              });
              this.getInitialState(drawerIsVisible).then((st) => {
                this.resetFields();
                this.setState(st);
              });
            } else {
              notification.error({
                message: "Fail",
                description: res.data.message || "Something went wrong!",
              });
              this.setState({
                tableData: { list: this.state.tableData.list, loading: false },
              });
            }
          })
          .catch(() => {
            this.setState({
              tableData: { list: this.state.tableData.list, loading: false },
            });
          });
      })
      .catch(() => {
        this.setState({
          tableData: { list: this.state.tableData.list, loading: false },
        });
      });
  };

  componentDidMount() {
    this._isMounted = true;
    this.getInitialState().then((st) =>
      this._isMounted ? this.setState(st) : null
    );
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <div>
        <Drawer
          title="New Asset Sub Location"
          placement="right"
          closable={false}
          onClose={() => {
            this.resetFields();
            this.setState({ editFormFields: [], drawerIsVisible: false });
          }}
          visible={this.state.drawerIsVisible}
          width={window.innerWidth - 40 > 400 ? 380 : window.innerWidth - 40}
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
              }}
            >
              <Button
                name="create"
                onClick={() => this.onCreateNew()}
                type="primary"
                style={{ borderRadius: 20 }}
              >
                {this.state.editFormFields.length ? "Save" : "Create"}
              </Button>
              {!this.state.editFormFields.length ? (
                <Button
                  style={{ borderRadius: 20 }}
                  onClick={() => this.onCreateNew(true)}
                  type="primary"
                >
                  Create and add another
                </Button>
              ) : null}
              <Button
                onClick={() => {
                  this.resetFields();
                  this.setState({
                    editFormFields: [],
                    drawerIsVisible: this.state.editFormFields.length > 0,
                  });
                }}
                style={{ borderRadius: 20 }}
              >
                Cancel
              </Button>
            </div>
          }
        >
          <Form
            requiredMark
            layout="horizontal"
            colon={false}
            ref={(ref) => (ref ? (this.formRef = ref) : null)}
            fields={this.state.editFormFields}
          >
            <Form.Item
              key="SubLocationID"
              name="SubLocationID"
              label="Sub Location ID"
              labelAlign="left"
              labelCol={{ span: 10 }}
              hidden
            >
              <Input disabled></Input>
            </Form.Item>
            <Form.Item
              key="SubLocationName"
              name="SubLocationName"
              label="Sub Location Name"
              labelAlign="left"
              labelCol={{ span: 10 }}
              rules={[
                { required: true, message: "Please enter sub location name" },
              ]}
            >
              <Input></Input>
            </Form.Item>
          </Form>
        </Drawer>
        <Row style={{ margin: "10px 10px 10px 10px" }}>
          <Col span={4}></Col>
          <Col span={16} style={{ textAlign: "center" }}>
            <h3>Asset Sub Location</h3>
          </Col>
          <Col span={4} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              onClick={() => {
                this.setState({ drawerIsVisible: true });
              }}
              style={{ borderRadius: 20 }}
            >
              New
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <Table
              loading={this.state.tableData.loading}
              dataSource={this.state.tableData.list}
              columns={this.columns}
              scroll={{ y: window.innerHeight - 225 }}
              pagination={false}
            ></Table>
          </Col>
        </Row>
      </div>
    );
  }
}

export default withRouter(AssetSubLocation);
